module.exports = __webpack_public_path__ + "static/media/logoKenetto-01.44839a8c.svg";